module.exports = __webpack_public_path__ + "images/94cd57f57042997d59523d8a30036cf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/matts_thumb.jpg
// module id = 136
// module chunks = 24